import { useCallback } from 'react'
import type { DiscountCouponCode } from '~/lib/graphql/scalars'
import {
  useApplyAcquiredCoupon,
  useDiscountCoupons,
  useSelectedAcquiredCouponCode,
} from '../../store/discountCoupon'
import { useDiscountCouponType } from '../../store/stateMachine/context'
import type { SelectedDiscountCouponType } from '../../store/stateMachine/statemachine'

export function useAcquireCoupons() {
  const coupons = useDiscountCoupons()
  const selectedCouponCode = useSelectedAcquiredCouponCode()
  const couponType = useDiscountCouponType()
  const apply = useApplyAcquiredCoupon()
  const changeCoupon = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      apply(e.target.value as DiscountCouponCode)
    },
    [apply]
  )

  return { coupons, selectedCouponCode, couponType, changeCoupon }
}

export function checkedAcquiredCoupon(
  couponCode: DiscountCouponCode,
  couponType?: SelectedDiscountCouponType,
  selectedCouponCode?: DiscountCouponCode
) {
  return selectedCouponCode === couponCode && couponType?.type === 'AcquiredCoupon'
}
if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest
  it('checkedAcquiredCoupon', async () => {
    expect(
      checkedAcquiredCoupon(
        '1234567890' as DiscountCouponCode,
        { type: 'AcquiredCoupon', code: '1234567890' as DiscountCouponCode },
        '1234567890' as DiscountCouponCode
      )
    ).toBe(true)
    expect(
      checkedAcquiredCoupon(
        '1234567891' as DiscountCouponCode,
        { type: 'AcquiredCoupon', code: '0987654321' as DiscountCouponCode },
        '1234567890' as DiscountCouponCode
      )
    ).toBe(false)
  })
}
